import * as React from 'react'
import styled from 'styled-components'
import DyProductSlider from 'theme/molecules/DyProductSlider'
import withTranslations from '../withTranslations'
import useTranslations from 'hooks/useTranslations'

export function LastSeenProducts() {
  const t = useTranslations<'account-Dashboard'>()
  return (
    <Wrapper className="LastSeenProducts">
      <DyProductSlider
        dySelector="wdv-1834-myaccount-recommendation-slot2"
        gridArea="Account-LastSeen"
        title={t('last_seen_products')}
      />
    </Wrapper>
  )
}

export default withTranslations(LastSeenProducts)

const Wrapper = styled.div``
